import Backbone from 'backbone';
import {ScaleLinear} from 'd3';

import CutSite from 'molbio/enzymes/backbone/CutSite';

export interface SliceAttributes {
  // TODO: methods that get/set these values directly instead of using the below methods sometimes coerce the value to be non-null. Update those later.
  start: number | null;
  end: number | null;
  height: number | null;
  width: number | null;
  leftBP: number | null;
  rightBP: number | null;
  maxWidth: number | null;
  visibleWidth: number | null;
  x: ScaleLinear<number, number> | null;
  xInv: ScaleLinear<number, number> | null;
  cutData: Array<CutSite>;
}

interface Slice {
  get<K extends keyof SliceAttributes>(key: K): SliceAttributes[K];
  set(obj: Partial<SliceAttributes>, options?: Backbone.ModelSetOptions & {skipUpdate?: boolean}): Slice;
  set<K extends keyof SliceAttributes>(key: K, value: SliceAttributes[K]): Slice;
}

class Slice extends Backbone.Model {
  defaults(): SliceAttributes {
    // leftBP and rightBP are only in client/maps/linear/MiniMap.js
    return {
      start: null,
      end: null,
      height: null,
      width: null,
      leftBP: null,
      rightBP: null,
      maxWidth: null,
      visibleWidth: null,
      x: null,
      xInv: null,
      cutData: [],
    };
  }

  // TODO: Each of these 4 following methods currently coerce the values to be non-null. Update these later.
  start(): number {
    return this.get('start')!;
  }

  end(): number {
    return this.get('end')!;
  }

  x(): ScaleLinear<number, number> {
    return this.get('x')!;
  }

  xInv(): ScaleLinear<number, number> {
    return this.get('xInv')!;
  }

  contains(index: number): boolean {
    const sStart = this.start();
    const sEnd = this.end();

    if (sStart < sEnd) {
      return sStart <= index && index < sEnd;
    } else {
      return index >= sStart || index < sEnd;
    }
  }
}

export default Slice;
